import { cn } from '../../../utils/className';
import type { ButtonVariant, ButtonSize } from './Button.types';

export const buttonStyles = {
  base: cn(
    'inline-flex items-center justify-center rounded-sm font-medium',
    'leading-[1.5] text-center align-middle cursor-pointer',
    'transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
    'disabled:opacity-50 disabled:pointer-events-none'
  ),

  variants: {
    primary: cn(),
    secondary: cn(
      'overflow-hidden relative text-[var(--color-gray-900)] border border-[var(--color-green-100)] bg-[var(--color-green-100)] bg-[image:linear-gradient(to_right,#d1f99c_50%,#fff_50%)] bg-[size:200%_100%] ',
      'hover:text-black hover:border-[var(--color-green-200)] bg-[var(--color-green-300)] hover:bg-[position:-100%_0%]',
      'focus:text-black focus:border-[var(--color-green-200)]',
      'focus:ring-[0_0_0_0.25rem_rgba(178,212,133,0.5)] focus:ring-offset-0',
      'active:text-black active:border-[#d6faa6] active:translate-y-[1px]',
      'disabled:opacity-60 disabled:cursor-not-allowed disabled:text-gray-500 disabled:border-gray-300'
    ),
    tabButton: cn(
      'relative overflow-hidden gap-2',
      'bg-[#3b4151] text-white text-left font-normal',
      '!px-5 rounded-xl',
      'border-4 border-[rgba(0,0,0,0)]',
      'hover:border-[#535e76]',
      'transition-colors duration-500',
      'focus:outline-none focus:text-white focus:border-[var(--color-gray-500)]',
      'focus:ring-[0_0_0_0.25rem_rgba(178,212,133,0.5)] focus:ring-offset-0',
      'active:text-white active:border-gray-500 active:translate-y-[1px]',
      'disabled:opacity-60 disabled:cursor-not-allowed disabled:text-gray-500 disabled:border-gray-300'
    ),
    darkSubmitButton: cn(
      'overflow-hidden relative bg-black text-white border border-black',
      'hover:opacity-90',
      'focus:outline-none focus:ring-0 focus:border-black',
      'active:translate-y-[1px]',
      'disabled:opacity-60 disabled:cursor-not-allowed'
    ),
    graySubmitButton: cn(
      'overflow-hidden relative bg-[var(--color-gray-950)] text-white border border-black',
      'hover:opacity-90',
      'focus:outline-none focus:ring-0 focus:border-black',
      'active:translate-y-[1px]',
      'disabled:opacity-60 disabled:cursor-not-allowed'
    ),
    outline: cn(),
    linkButton: cn(
      'font-semibold',
      'overflow-hidden relative text-[var(--color-gray-900)] bg-transparent bg-[image:linear-gradient(to_right,#d1f99c_50%,#fff_0%)] bg-[size:200%_100%] ',
      'hover:text-black bg-[var(--color-green-300)] hover:bg-[position:-100%_0%]',
      'focus:text-black ',
      'focus:ring-[0_0_0_0.25rem_rgba(178,212,133,0.5)] focus:ring-offset-0',
      'active:text-black active:border-[#d6faa6] active:translate-y-[1px]',
      'disabled:opacity-60 disabled:cursor-not-allowed disabled:text-gray-500 disabled:border-gray-300'

    ),
  } as Record<ButtonVariant, string>,

  sizes: {
    sm: cn('px-0 pe-2 py-0 text-base'),
    md: cn('px-4 py-2 text-base'),
    lg: cn('px-5 py-2.5 text-lg'),
    xl: cn('px-7 py-5 text-base'),
    full: cn('px-7 py-5 text-[1.25rem]'),
  } as Record<ButtonSize, string>,

  modifiers: {
    fullWidth: 'w-full',
    loading: 'cursor-not-allowed opacity-60',
  },
};
